import React, { useState, useEffect } from "react";
import CommonModal from "../../../../common/commonmodal/CommonModal";
import CustomSelect from "../../../../common/formfields/CustomSelect";

const GenerateSlotsModal = ({ isOpen, onClose, onGenerate, floorOptions = [], wingOptions = [], parkingTypeOptions = [] }) => {
    const [formData, setFormData] = useState({
        wingId: "",
        floor: "",
        parkingTypeId: "",
        quantity: ""
    });

    useEffect(() => {
        if (isOpen) {
            setFormData({
                wingId: "",
                floor: "",
                parkingTypeId: "",
                quantity: ""
            });
        }
    }, [isOpen]);

    const handleSubmit = () => {
        onGenerate(formData);
        onClose();
    };

    // CustomSelect passes the full option object {label, value, original} to onChange
    const selectedTypeId = formData.parkingTypeId?.value || formData.parkingTypeId;
    const selectedType = parkingTypeOptions.find(p => p.value === selectedTypeId);
    
    const isStack = (selectedType?.original?.StructureType || selectedType?.original?.structureType)?.toLowerCase() === "stack";
    const capacity = selectedType?.original?.Capacity || selectedType?.original?.capacity || 1;
    const totalSlots = (parseInt(formData.quantity) || 0) * capacity;

    const selectedWingId = formData.wingId?.value || formData.wingId;
    const filteredFloorOptions = selectedWingId 
        ? floorOptions.filter(f => (f.original.WingId || f.original.wingId) == selectedWingId) 
        : floorOptions;

    return (
        <CommonModal
            isOpen={isOpen}
            onClose={onClose}
            title="Generate New Parking Slots"
            width="md:w-[500px]"
        >
            <div className="flex flex-col gap-6 pt-2">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-xs font-semibold text-gray-700 dark:text-textprimary mb-1.5">
                            Target Wing
                        </label>
                        <CustomSelect
                            options={wingOptions}
                            value={formData.wingId}
                            onChange={(val) => {
                                setFormData(prev => ({ ...prev, wingId: val, floor: "" }));
                            }}
                            placeholder="Select a wing..."
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-gray-700 dark:text-textprimary mb-1.5">
                            Target Onboarded Floor
                        </label>
                        <CustomSelect
                            options={filteredFloorOptions}
                            value={formData.floor}
                            onChange={(val) => setFormData(prev => ({ ...prev, floor: val }))}
                            placeholder="Select a floor..."
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-gray-700 dark:text-textprimary mb-1.5">
                            Structure Type
                        </label>
                        <CustomSelect
                            options={parkingTypeOptions}
                            value={formData.parkingTypeId}
                            onChange={(val) => setFormData(prev => ({ ...prev, parkingTypeId: val }))}
                            placeholder="Select structure type..."
                        />
                    </div>

                    <div className="w-full">
                        <label className="block text-xs font-semibold text-gray-700 dark:text-textprimary mb-1.5">
                            {isStack ? "Quantity of Stack Systems" : "Quantity of Standard Bays"}
                        </label>
                        <input
                            type="number"
                            min="1"
                            placeholder="Enter quantity"
                            value={formData.quantity}
                            onChange={(e) => setFormData(prev => ({ ...prev, quantity: e.target.value === "" ? "" : parseInt(e.target.value) || 0 }))}
                            className="w-full px-3 py-2 bg-white dark:bg-actionitembg border border-gray-200 dark:border-bordercolor rounded-md text-sm text-gray-800 dark:text-textprimary focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                        />
                    </div>
                </div>



                <div className="flex items-center justify-between p-3 bg-blue-50/50 dark:bg-dashboardbg border border-blue-100 dark:border-bordercolor rounded-lg mt-2">
                    <span className="text-xs font-medium text-gray-600 dark:text-textsecondary">
                        Total Slots to be Created:
                    </span>
                    <span className="text-sm font-bold text-blue-600 dark:text-blue-400">
                        {totalSlots} Slots
                    </span>
                </div>

                <div className="flex justify-end gap-3 mt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-1.5 text-xs font-bold text-gray-700 dark:text-textprimary hover:bg-gray-100 dark:hover:bg-actionitembg rounded-lg transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={!formData.floor || !formData.parkingTypeId || formData.quantity <= 0}
                        className="px-4 py-1.5 text-xs font-bold text-white bg-red-600 hover:bg-red-700 rounded-lg disabled:opacity-50 transition-colors shadow-sm"
                    >
                        Generate Stock
                    </button>
                </div>
            </div>
        </CommonModal>
    );
};

export default GenerateSlotsModal;
